import { BaseService } from './base'
import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'

class Impersonation {
    // POST /Users/ImpersonateStart?targetUserId=X&reason=Y -> { Token, HardCapExpiresAtUtc, ... }
    start(targetUserId, reason) {
        const params = CommonUtility.objectToParams({ targetUserId, reason })
        return BaseService.post(`${APIPath.impersonateStart}?${params}`, null)
    }

    // POST /Users/ImpersonateEnd -> { AdminToken, ... }
    end() {
        return BaseService.post(APIPath.impersonateEnd, null)
    }

    // POST /Users/ImpersonateForceEnd/{sessionId}
    forceEnd(sessionId) {
        return BaseService.post(APIPath.impersonateForceEnd(sessionId), null)
    }

    // GET /Users/ImpersonationHistory?fromUtc=&toUtc=&targetCompanyId=&actorUserId=&pageNumber=1&pageSize=20
    history(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(`${APIPath.impersonationHistory}?${params}`)
    }
}

const ImpersonationService = new Impersonation()
Object.freeze(ImpersonationService)
export { ImpersonationService }
